<template>
	<md-menu @md-opened="onMenuOpen" ref="menu">
		<md-field :class="[{ 'md-error': error }]">
			<label>{{ labelText }}</label>
			<!-- TODO: Add keyboard support-->
			<md-input :value="selectedValuesDisplay"
					  :disabled="disabled"
					  :required="required"
					  readonly
					  @click="toggleMenu"
					  class="pointer"
			/>
			<!-- Matches style of select dropdown icon -->
			<div @click="toggleMenu">
				<md-icon class="md-icon-image pointer" v-once>
					<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
						<path d="M7 10l5 5 5-5z"/>
						<path d="M0 0h24v24H0z" fill="none"/>
					</svg>
				</md-icon>
			</div>
			<span v-if="error" class="validation-error">{{ error }}</span>
		</md-field>

		<keep-alive>
			<md-menu-content class="tree-select-menu tree-select-menu-dense" :class="contentClass" :style="contentStyle">
				<md-menu-item>
					<md-field v-if="searchAllow">
						<label>{{ $t("common.search") }}</label>
						<md-input @input="search" :value="searchValue"></md-input>
					</md-field>
				</md-menu-item>

				<md-menu-item>
					<el-tree :data="treeOptions"
							 :props="treeProperties"
							 :node-key="treeProperties.nodeKey"
							 @check="onNodeChecked"
							 :filter-node-method="filterTreeNode"
							 :show-checkbox="true"
							 :highlight-current="true"
							 :empty-text="emptyText"
							 :class="treeClass"
							 ref="tree"
					></el-tree>
				</md-menu-item>
			</md-menu-content>
		</keep-alive>
	</md-menu>
</template>

<script>
import TreeSelectBaseComponent from "@/components/templates/common/TreeSelectBaseComponent";

export default {
	extends: TreeSelectBaseComponent,
	props: {
		value: { type: Array, default: [] },
		labelText: { type: String, default: "" },
		selectedValuesTextMultiple: { type: String, default: "" }, // Manually set text for multiple selected options
		selectedValuesTextSingle: { type: String, default: "" }, // Manually set text for multiple selected options
		contentSize: { type: "small" | "medium" | "large" | "xl" | "auto", default: "medium" },
		autoMaxWidth: { type: Number, default: "100%" }, // Only applicable if content size is "auto"
		autoMaxHeight: { type: Number, default: "50%" }, // Only applicable if content size is "auto"
		treeClass: { type: String | Array, default: null }, // General class applied to the tree
		error: { type: String, default: "" },
	},
	data() {
		return {
			selectedValuesDisplay: ""
		}
	},
	mounted() {
		this.updateSelectedDisplay();
	},
	computed: {
		contentClass() {
			return "tree-select-menu-content-" + this.contentSize;
		},
		contentStyle() {
			if (this.contentSize !== "auto") {
				return "";
			}

			let maxWidthStyle = "maxWidth: " + this.autoMaxWidth + "!important;";
			let maxHeightStyle = "maxHeight: " + this.autoMaxHeight + "!important;";

			return maxWidthStyle + maxHeightStyle;
		},
	},
	methods: {
		toggleMenu() {
			this.$refs.menu.toggleContent();
		},
		onMenuOpen() {
			// Need to wait for tree to be rendered
			this.$nextTick(() => {
				this.syncTreeState();
			});
		},
		updateSelectedDisplay() {
			if (this.value.length === 0) {
				this.selectedValuesDisplay = "";
			} else if (this.value.length === 1 && this.selectedValuesTextSingle) {
				this.selectedValuesDisplay = this.selectedValuesTextSingle
			} else if (this.value.length > 1 && this.selectedValuesTextMultiple) {
				this.selectedValuesDisplay = this.selectedValuesTextMultiple
			} else {
				// Cannot use the checked tree nodes because it might not be rendered or still out of sync if the selected values changed from the outside
				// So we need to look up the options data by searching through the data itself
				this.selectedValuesDisplay = this.findOptionsForSelectedValues().map(this.getOptionDisplayValue).join(", ");
			}
		},
		findOptionsForSelectedValues() {
			// No options, so nothing to look for
			if (!this.options) {
				return [];
			}

			let stack = [...this.options]
			let result = [];

			while (stack.length > 0 && result.length < this.value.length) {
				const option = stack.shift();

				if (this.value.includes(this.getOptionValue(option))) {
					result.push(option);
				}

				stack.unshift(...option[this.optionsChildrenField]);
			}

			return result;
		}
	},
	watch: {
		value() {
			this.updateSelectedDisplay();
		},
		options() {
			this.updateSelectedDisplay();
		}
	}
};
</script>